import RoutesSignalerErreur from './signaler-erreur/routes';
import RoutesSignalerArmeManquante from './signaler-arme-manquante/routes';
import RoutesSignalerArmePerdueVolee from './signaler-perte-vol/routes';
import RoutesDemanderImpression from './demander-impression/routes';
import RoutesRepriseDonnees from '../ratelier/armes/components/repriseDeDonnees/CorrigerArme/routes';
import RoutesSupprimerArme from './supprimer/routes';
import RoutesDemandeArmeTrouvee from './demande-arme-trouvee/routes';
import RoutesDemandeArmeHeritee from './demande-arme-heritee/routes';
import { initSubRoutes } from '../../../utils/router';

const RoutesArmes = initSubRoutes({
    route: '/armes',
    subroutes: {
        signalerErreur: RoutesSignalerErreur,
        signalerArmeManquante: RoutesSignalerArmeManquante,
        signalerArmePerdueVolee: RoutesSignalerArmePerdueVolee,
        demanderImpression: RoutesDemanderImpression,
        repriseDonnees: RoutesRepriseDonnees,
        supprimerArme: RoutesSupprimerArme,
        demandeArmeTrouvee: RoutesDemandeArmeTrouvee,
        demandeArmeHeritee: RoutesDemandeArmeHeritee,
    },
    nom: 'Armes',
});

export default RoutesArmes;
